export default {};
//# sourceMappingURL=NativeScreensModule.web.js.map